import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoUser, DtoUser } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoUserEntityDataService } from '../interfaces/dto.user.entity.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoUserEntityDataService extends EntityDataService<IDtoUser> implements IDtoUserEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  public getUserByUserName$(userName: string): Observable<IDtoUser> {
    return this.httpGet(`${this.apiUrl}/${userName}`)
      .pipe(map((json: IDtoUser) => {
        let result: IDtoUser = null;
        if (UtilsMisc.isNullOrUndefined(json) === false) {
          result = this.createEntityFromJson(json);
        }
        return result;
      }));
  }

  public async getUserByUserNameAsync(userName: string): Promise<IDtoUser> {
    return (await this.getUserByUserName$(userName).toPromise());
  }

  public getWebUsersForMandator$(mandatorId: number): Observable<IDtoUser[]> {
    return this.httpGet(`${this.apiUrl}/mandator/${mandatorId}/userRoles/DISPATCHER,ADMIN`)
      .pipe(map((entities: IDtoUser[]) => {
        const result: IDtoUser[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getWebUsersForMandatorAsync(mandatorId: number): Promise<IDtoUser[]> {
    return (await this.getWebUsersForMandator$(mandatorId).toPromise());
  }

  public getDeviceUsersForMandator$(mandatorId: number): Observable<IDtoUser[]> {
    return this.httpGet(`${this.apiUrl}/mandator/${mandatorId}/userRoles/MOBILE`)
      .pipe(map((entities: IDtoUser[]) => {
        const result: IDtoUser[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getDeviceUsersForMandatorAsync(mandatorId: number): Promise<IDtoUser[]> {
    return (await this.getDeviceUsersForMandator$(mandatorId).toPromise());
  }

  public getUsersForDepot$(depotNumber: string): Observable<IDtoUser[]> {
    return this.httpGet(`${this.apiUrl}/depot/${depotNumber}`)
      .pipe(map((entities: IDtoUser[]) => {
        const result: IDtoUser[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getUsersForDepotAsync(depotNumber: string): Promise<IDtoUser[]> {
    return (await this.getUsersForDepot$(depotNumber).toPromise());
  }

  protected override doGetApiUrl(): string {
    return '/api/web/users'
  }

  protected override createEntityFromJson(json: any): IDtoUser {
    const result: IDtoUser = (UtilsJson.deserialize(json, DtoUser) as IDtoUser);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

  protected override doGetUrls(): IUtilsDictionary<string> {
    this._urls = super.doGetUrls();

    // Fix URLs that need proper slash separator
    this._urls.set('getbyid', `${this.apiUrl}/{0}`);
    this._urls.set('delete', `${this.apiUrl}/{0}`);

    this._urls.add('get.by.mandator.userroles', UtilsString.stringFormat('{0}://{1}:{2}/{3}/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + 'mandator/{0}/userroles/{1}');
    this._urls.add('get.by.username', UtilsString.stringFormat('{0}://{1}:{2}/{3}/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + '{0}');
    this._urls.add('get.for.depot', UtilsString.stringFormat('{0}://{1}:{2}/{3}/depot/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + '{0}');

    return this._urls;
  }

}
